<template>
  <div>
    <v-toolbar class="elevation-0 transparent">
      <v-layout align-start>
      <v-flex xs12 class="topLogo">
        <!-- <div class="mx-auto" > -->
        <v-img contain :src="headerImage()" max-height="50" alt="logo" />
        <!-- </div> -->
      </v-flex>
        <v-flex xs12 class="topName">
          <h1><b>{{headerName()}}</b></h1>
        </v-flex>
      </v-layout>
      <v-flex xs12 sm4 class="mb-4">
        <v-layout row justify-end>
          <v-flex xs3 xl2 justify-end class="zindex">
            <div class="languageIcons text-xs-center">
              <v-menu bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-avatar size="35" class="mr-4" v-on="on">
                    <img :aspect-ratio="14/9" :src="languageLogo" />
                  </v-avatar>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(item, i) in languages"
                    :key="i"
                    @click="changeUserLanguage(item)"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="item.LanguageIcon"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{ item.Language }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
            <v-menu class="menuList" offset-y>
              <v-btn
                v-if="userLevel >= 0 && userLevel <= 9"
                slot="activator"
                @click="$emit('showLogin')"
                icon
              >
                <v-icon>menu</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="goToHome">
                  <v-list-tile-title>Home</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="userLevel >= 1" @click="goToMyAppointments">
                  <v-list-tile-title>{{$translate('MY_APPOINTMENTS')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="userLevel >= 1" @click="goToPage('UserSettings')">
                  <v-list-tile-title>{{$translate('SETTINGS')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="userLevel >= 6 && userLevel <= 9"
                  @click="showComponents({ main: 'EventView_Main', side: 'EventView_Overview' })"
                >
                  <v-list-tile-title>{{$translate('DASHBOARD_TITLE')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="userLevel !== 0" @click="logout">
                  <v-list-tile-title>Log out</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-else @click="login">
                  <v-list-tile-title>Login</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <!-- </div> -->
        </v-layout>
      </v-flex>
    </v-toolbar>
    <LoginPopup v-if="showLogin" @close="showLogin = !showLogin" />
    <br />
    <hr />
  </div>
</template>

<script>
import LoginPopup from "@/components/LoginPopup";
import appConfig from "../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import * as dssRequest from "@/api/dssRequest";
import UserObject from "@/objects/UserObject";
import _ from "lodash";
import { mapGetters } from "vuex";
import { ui_helpers } from "@/shared/ui_helpers";
import BaseComponent from "@/components/base/BaseComponent.vue";

export default {
  name: "cp-header",
  mixins: [ui_helpers],
  extends: BaseComponent,
  components: {
    LoginPopup
  },
  computed: {
    // getAuthorizationForAdminAndTrial: function() {
    //   // is Tag administrator present ?
    //   return (
    //     this.authType >= 2 &&
    //     null !== this.user &&
    //     undefined !== this.user.tags &&
    //     undefined !==
    //       this.user.tags.find(
    //         e =>
    //           e.Description === "Administrator" &&
    //           e.Selected === "yes" &&
    //           e.AccountId == this.currentAccountId
    //       )
    //   );
    // }
  },
  // created() {
  //   this.readInputParams();
  // },
  mounted() {


    this.getAllLanguageTags();
    // if (this.$store.getters.getUserLanguage !== "") {
    //   this.changeUserLanguage(this.$store.getters.getUserLanguage);
    // } else {
    //   this.$store.commit("setLanguage", "NL");
    //   this.$store.commit("setUserLanguage", "14");
    //   this.languageLogo = require("@/assets/countryIcons/netherlands.png");
    // }
  },
  methods: {
    headerName() {
      if (this.$store.getters.getAccountInfo.CompanyName !== "") {
        return this.$store.getters.getAccountInfo.CompanyName;
      }
      return "";
    },
    changeUserLanguage(item) {
      if (!item.hasOwnProperty("Language")) {
        if (item == "13") {
          this.languageLogo = require("@/assets/countryIcons/united-kingdom.png");
          this.$store.commit("setUserLanguage", item);
          this.$store.commit("setLanguage", "EN");
        } else if (item == "14") {
          this.languageLogo = require("@/assets/countryIcons/netherlands.png");
          this.$store.commit("setUserLanguage", item);
          this.$store.commit("setLanguage", "NL");
        } else if (item == "15") {
          this.languageLogo = require("@/assets/countryIcons/italy.png");
          this.$store.commit("setUserLanguage", item);
          this.$store.commit("setLanguage", "EN");
        } else if (item == "16") {
          this.languageLogo = require("@/assets/countryIcons/france.png");
          this.$store.commit("setUserLanguage", item);
          this.$store.commit("setLanguage", "EN");
        } else if (item == "17") {
          this.languageLogo = require("@/assets/countryIcons/germany.png");
          this.$store.commit("setUserLanguage", item);
          this.$store.commit("setLanguage", "DE");
        }
      } else {
        this.languageLogo = item.LanguageIcon;
        this.updateLanguage(item.LanguageTagId);
        if (item.LanguageTagId === "14") {
          this.$store.commit("setLanguage", "NL");
        } else if (item.LanguageTagId === "17") {
          this.$store.commit("setLanguage", "DE");
        } else {
          this.$store.commit("setLanguage", "EN");
        }
      }
    },
    updateLanguage(id) {
      if(!_.isEmpty(this.$store.getters["auth/userName"])){
        const payload = {
          LanguageTagId: Number(id)
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call updateLanguage was successful",
              response
            );
            console.log("FIRENEWLANGUAGE CALLED FROM CPHEADER")
            window.EventBus.fire("fireNewLanguage",{})
          },
          error => {
            console.log(
              "The generic call updateLanguage was not successful",
              error
            );
          },
          "updateLanguage",
          this.$store.getters["auth/userName"],
          payload
        );
      }
    },
    // Get all language tags from the database.
    getAllLanguageTags() {
      // This used to be the generic call getAllLanguageTags
      const payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getAllLanguageTags was successful",
            response
          );
          if (!response.hasOwnProperty("data")) {
            console.error(
              "[" +
                this.$options.name +
                "] Response on getAllLanguageTags() doesn't have data."
            );
            return;
          }

          if (!response.data.hasOwnProperty("Languages")) {
            console.error(
              "[" +
                this.$options.name +
                "] Response on getAllLanguageTags() doesn't have Languages."
            );
            return;
          }

          this.languages = [];
          this.languages = [...response.data.Languages];
          
          this.languages.forEach(data => {
            if(data.Icon === '' || data.Icon === 'NULL') {
              if (data.LanguageId == "13") {
                data.Icon = require("@/assets/countryIcons/united-kingdom.png");
              } else if (data.LanguageId == "14") {
                data.Icon = require("@/assets/countryIcons/netherlands.png");
              } else if (data.LanguageId == "15") {
                data.Icon = require("@/assets/countryIcons/italy.png");
              } else if (data.LanguageId == "16") {
                data.Icon = require("@/assets/countryIcons/france.png");
              } else if (data.LanguageId == "17") {
                data.Icon = require("@/assets/countryIcons/germany.png");
              }
            }
          });
        },
        error => {
          console.log(
            "The generic call getAllLanguageTags was not successful",
            error
          );
        },
        "getAllLanguageTags",
        this.currentAccountId,
        payload
      );
    },
    readInputParams() {
      this.email = this.$route.query.email;
      this.userID = this.$route.query.UserID;
      this.$store.commit("auth/setUserName", this.userID);
      this.passwordHash = this.$route.query.token;
      this.type = this.$route.query.type;
    },
    setUserHomepage() {
      this.$store.commit("setWebStepId", 2);
    },

    goToMyAppointments() {
      this.goToPage("UserTripList");
      // this.$store.commit("setWebStepId", 2);
    },
    goToHome() {
      this.$router.push({
        name: "Home",
        params: "component"
      });
      this.$store.commit("setWebStepId", 1);
    },
    login() {
      this.$router.push({
        name: "Login",
        params: {
          type: "u",
          account_id: this.$store.getters.getRegion
        }
      });
    },
    logout() {
      this.$store.dispatch("auth/logout");
      window.EventBus.fire("getAccountInfo", {});
      this.$store.commit("setSavePartnerId", '');
      this.$store.commit("setRedirectedFromPearlCalendar", false);
      this.$store.commit("auth/setUserType", "u");
      this.$store.commit("setWebStepId", 2);
      this.isLoggedIn = false;
      this.$router.push({
        name: "Home",
        params: {
          type: "u",
          account_id: this.$store.getters.getRegion
        }
      });
      window.EventBus.fire("activateSnackBar", this.$translate('USER_LOGGED_OUT'));
    }
  },

  data() {
    return {
      languages: [],
      languageLogo: "",
      isLoggedIn: false,
      showLogin: false,
      showPushNotifications: false,
      selectedUserGroup: null,
      itemDisabled: [0]
    };
  }
};
</script>

<style scoped>
.headerItems {
  width: 120px;
  margin-left: auto;
}

#NL {
  float: left;
  display: none;
}

#EN {
  float: left;
}
.subItems {
  width: 250px !important;
}

.languageButton {
  /*background-color: #2D155B !important;*/
  color: white !important;
}
.languageIcons {
  margin-top: 4em;
  margin-left: -10em !important;
}
.zindex {
  margin-right: -5em;
  z-index: 999;
}
.menuList {
  margin-top: -4em;
}
.topLogo{
  margin-left: -18em !important;
}
.topName{
  margin-right: -20em !important;
}
</style>
